import { dataAbstractSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAbstractSolid = /*#__PURE__*/createIcon(dataAbstractSolid)
export default IconAbstractSolid
